module.exports = __webpack_public_path__ + "img/awards_20.f0ec73b1.png";